import React, { useState } from "react";
import { api } from "../api";

export default function Login({ onLoginSuccess }) {
  const [step, setStep] = useState(1);
  const [empId, setEmpId] = useState("EMP001");
  const [password, setPassword] = useState("Admin@2026");
  const [otp, setOtp] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.login(empId, password);
      setSessionId(res.session_id);
      setStep(2);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.verifyOtp(sessionId, otp);
      localStorage.setItem("auth_token", res.token);
      onLoginSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="card" style={{ width: "100%", maxWidth: "400px" }}>
        <h2 style={{ marginBottom: "1rem", color: "var(--navy-primary)" }}>Operator Portal</h2>
        {error && <div style={{ color: "var(--danger)", marginBottom: "1rem", fontSize: "0.875rem" }}>{error}</div>}

        {step === 1 ? (
          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: "1rem" }}>
              <label className="card-label">Employee ID</label>
              <input type="text" className="card" style={{ width: "100%", padding: "0.6rem" }} value={empId} onChange={(e) => setEmpId(e.target.value)} required />
            </div>
            <div style={{ marginBottom: "1.5rem" }}>
              <label className="card-label">Password</label>
              <input type="password" className="card" style={{ width: "100%", padding: "0.6rem" }} value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: "100%" }} disabled={loading}>
              {loading ? "Verifying..." : "Generate OTP"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleVerifyOtp}>
            <div style={{ marginBottom: "1.5rem" }}>
              <label className="card-label">Enter 6-Digit OTP</label>
              <input type="text" maxLength="6" className="card" style={{ width: "100%", padding: "0.6rem", fontSize: "1.25rem", textAlign: "center", letterSpacing: "4px" }} value={otp} onChange={(e) => setOtp(e.target.value)} required />
              <p style={{ fontSize: "0.75rem", color: "var(--text-muted)", marginTop: "0.5rem" }}>Sent to administrator mobile. Valid for 5 minutes.</p>
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: "100%" }} disabled={loading}>
              {loading ? "Validating..." : "Verify & Access"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}